import { deleteAccountsApi, getSecureAccountsApi, postSecureAccountsApi, putAccountsApi } from "@Shared/@Utils/ajax";
export const getPaymentDetails = async () => {
  return getSecureAccountsApi({}, "/payment");
};
export const subscribeToPlan = async (accountsToPay, planDuration) => {
  return postSecureAccountsApi({
    accountsToPay,
    planDuration
  }, "/plan/subscribe");
};
export const setDefaultMethod = async paymentId => {
  return postSecureAccountsApi({}, `/payment/${paymentId}/default`);
};
export const cancelPlan = async accountsToCancel => {
  return postSecureAccountsApi({
    accountsToCancel
  }, "/plan/cancel");
};
export const getAccountUsage = async (feature = "") => {
  return getSecureAccountsApi(feature ? {
    feat: feature
  } : {}, "/limit");
};
export const editPaymentMethod = async (paymentId, cardExpMonth, cardExpYear, address) => {
  return putAccountsApi({
    cardExpMonth,
    cardExpYear,
    address
  }, `/payment/${paymentId}`);
};
export const deletePaymentMethod = async paymentId => {
  return deleteAccountsApi(`/payment/${paymentId}`);
};